import type { BannerBlock as BannerBlockProps } from 'src/payload-types'

import { cn } from '@/utilities/ui'
import React from 'react'
import RichText from '@/components/RichText'

type Props = {
  className?: string
} & BannerBlockProps

export const BannerBlock: React.FC<Props> = ({ className, content, style }) => {
  return (
    <RichText
      className={cn(
        'mx-auto my-8 w-full border py-3 px-6 flex items-center rounded-2xl',
        {
          'border-border bg-card': style === 'info',
          'border-error bg-error/30': style === 'error',
          'border-success bg-success/30': style === 'success',
          'border-warning bg-warning/30': style === 'warning',
        },
        className,
      )}
      data={content}
      enableGutter={false}
      enableProse={false}
      resetChildMargins
    />
  )
}
